import { Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const CircularProgressBox = () => {
  const { darkMode } = useSelector((state) => state.theme);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: `${darkMode ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)"}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress size={50} />
    </Box>
  );
};

export default CircularProgressBox;
